
/*
██████╗  ██████╗ ██╗   ██╗████████╗███████╗███████╗
██╔══██╗██╔═══██╗██║   ██║╚══██╔══╝██╔════╝██╔════╝
██████╔╝██║   ██║██║   ██║   ██║   █████╗  ███████╗
██╔══██╗██║   ██║██║   ██║   ██║   ██╔══╝  ╚════██║
██║  ██║╚██████╔╝╚██████╔╝   ██║   ███████╗███████║
╚═╝  ╚═╝ ╚═════╝  ╚═════╝    ╚═╝   ╚══════╝╚══════╝
*/

import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

// Importação das rotas
import RouteAuth from './routes/auth'
import RouteDashboard from './routes/dashboard'
import RouteContacts from './routes/contacts'
import RouteServices from './routes/services'
import RouteSettings from './routes/settings'
import RouteProfile from './routes/profile'
import RouteErrors from './routes/errors'

Vue.use(Router)

// Montamos um array geral com os arrays das rotas
let arrayRoutes = [
    ...RouteAuth,
    ...RouteDashboard,
    ...RouteContacts,
    ...RouteServices,
    ...RouteSettings,
    ...RouteProfile,
    ...RouteErrors
]

// Instanciando a rota
const router = new Router(
    {
        base: process.env.BASE_URL,
        routes: arrayRoutes
    }
)

/**
 * Devemos checar aqui se o usuário vai ter acesso a determinada rota
 * caso contrário devemos mandar ele de volta ao dashboard ou ao
 * login caso não tiver logado
 */

router.beforeEach((to, from, next) => {
    if (!store.state.authenticated && to.meta.auth) {
        return router.push({ name: 'auth.login' }).catch(err => { if (err) console.log(err.name || '') })
    }

    if ((to.meta.permition && store.state.user && !to.meta.permition.includes(store.state.user.permition)) || (to.meta.permition_company && store.state.user && !to.meta.permition_company.includes(store.state.company.customType))) {
        return router.push({ name: 'app.error.permission' }).catch(err => { if (err) console.log(err.name || '') })
    }

    next()
})

export default router
